module.exports = __webpack_public_path__ + "img/toilet.3c5fdbf0.svg";